import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import { createBrowserHistory } from 'history';
import thunk from 'redux-thunk';
import saga from 'redux-saga';

import rootReducer from './reducer';
import programSaga from '../program/saga';
import onboarderSaga from '../onboarder/saga';
import htmlSaga from '../html/saga';

export const history = createBrowserHistory();

const initialState = {};

const sagaMiddleware = saga();

const middlewares = [sagaMiddleware, thunk, routerMiddleware(history)];

const enhancers = [applyMiddleware(...middlewares)];

// If Redux DevTools Extension is installed use it, otherwise use Redux compose
/* eslint-disable no-underscore-dangle, indent */
const composeEnhancers =
  process.env.NODE_ENV !== 'production' && typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      // Prevent recomputing reducers for `replaceReducer`
      shouldHotReload: false
    })
    : compose;
/* eslint-enable */

const store = createStore(rootReducer, initialState, composeEnhancers(...enhancers));

// Run saga
sagaMiddleware.run(programSaga);
sagaMiddleware.run(onboarderSaga);
sagaMiddleware.run(htmlSaga);

export default store;



// WEBPACK FOOTER //
// ./src/containers/app/store.js